"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6462],{

/***/ 96462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HeaderSearchModal": function() { return /* binding */ HeaderSearchModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useId.js
var useId = __webpack_require__(57579);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(19267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 18 modules
var styled = __webpack_require__(74786);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Dialog/dialogClasses.js

function getDialogUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiDialog', slot);
}
const dialogClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
/* harmony default export */ var Dialog_dialogClasses = (dialogClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Dialog/DialogContext.js

const DialogContext = /*#__PURE__*/(0,react.createContext)({});

if (false) {}

/* harmony default export */ var Dialog_DialogContext = (DialogContext);
// EXTERNAL MODULE: ./node_modules/@mui/material/Backdrop/Backdrop.js + 2 modules
var Backdrop = __webpack_require__(77227);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Dialog/Dialog.js


const _excluded = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
















const DialogBackdrop = (0,styled/* default */.ZP)(Backdrop/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Backdrop',
  overrides: (props, styles) => styles.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
});

const useUtilityClasses = ownerState => {
  const {
    classes,
    scroll,
    maxWidth,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ['root'],
    container: ['container', `scroll${(0,capitalize/* default */.Z)(scroll)}`],
    paper: ['paper', `paperScroll${(0,capitalize/* default */.Z)(scroll)}`, `paperWidth${(0,capitalize/* default */.Z)(String(maxWidth))}`, fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
  };
  return (0,composeClasses/* default */.Z)(slots, getDialogUtilityClass, classes);
};

const DialogRoot = (0,styled/* default */.ZP)(Modal/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  '@media print': {
    // Use !important to override the Modal inline-style.
    position: 'absolute !important'
  }
});
const DialogContainer = (0,styled/* default */.ZP)('div', {
  name: 'MuiDialog',
  slot: 'Container',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.container, styles[`scroll${(0,capitalize/* default */.Z)(ownerState.scroll)}`]];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  height: '100%',
  '@media print': {
    height: 'auto'
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, ownerState.scroll === 'body' && {
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  '&:after': {
    content: '""',
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    width: '0'
  }
}));
const DialogPaper = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`scrollPaper${(0,capitalize/* default */.Z)(ownerState.scroll)}`], styles[`paperWidth${(0,capitalize/* default */.Z)(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  margin: 32,
  position: 'relative',
  overflowY: 'auto',
  // Fix IE11 issue, to remove at some point.
  '@media print': {
    overflowY: 'visible',
    boxShadow: 'none'
  }
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100% - 64px)'
}, ownerState.scroll === 'body' && {
  display: 'inline-block',
  verticalAlign: 'middle',
  textAlign: 'left' // 'initial' doesn't work on IE11

}, !ownerState.maxWidth && {
  maxWidth: 'calc(100% - 64px)'
}, ownerState.maxWidth === 'xs' && {
  maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `${theme.breakpoints.values.xs}${theme.breakpoints.unit}`,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.maxWidth !== 'xs' && {
  maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.fullWidth && {
  width: 'calc(100% - 64px)'
}, ownerState.fullScreen && {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: 'none',
  borderRadius: 0,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    margin: 0,
    maxWidth: '100%'
  }
}));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

const Dialog = /*#__PURE__*/react.forwardRef(function Dialog(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDialog'
  });
  const theme = (0,useTheme/* default */.Z)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    'aria-describedby': ariaDescribedby,
    'aria-labelledby': ariaLabelledbyProp,
    BackdropComponent,
    BackdropProps,
    children,
    className,
    disableEscapeKeyDown = false,
    fullScreen = false,
    fullWidth = false,
    maxWidth = 'sm',
    onBackdropClick,
    onClose,
    open,
    PaperComponent = Paper/* default */.Z,
    PaperProps = {},
    scroll = 'paper',
    TransitionComponent = Fade/* default */.Z,
    transitionDuration = defaultTransitionDuration,
    TransitionProps
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth,
    scroll
  });

  const classes = useUtilityClasses(ownerState);
  const backdropClick = react.useRef();

  const handleMouseDown = event => {
    // We don't want to close the dialog when clicking the dialog content.
    // Make sure the event starts and ends on the same DOM element.
    backdropClick.current = event.target === event.currentTarget;
  };

  const handleBackdropClick = event => {
    // Ignore the events not coming from the "backdrop".
    if (!backdropClick.current) {
      return;
    }

    backdropClick.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };

  const ariaLabelledby = (0,useId/* default */.Z)(ariaLabelledbyProp);
  const dialogContextValue = react.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    BackdropProps: (0,esm_extends/* default */.Z)({
      transitionDuration,
      as: BackdropComponent
    }, BackdropProps),
    closeAfterTransition: true,
    BackdropComponent: DialogBackdrop,
    disableEscapeKeyDown: disableEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref,
    onClick: handleBackdropClick,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
      appear: true,
      in: open,
      timeout: transitionDuration,
      role: "presentation"
    }, TransitionProps, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContainer, {
        className: (0,clsx_m/* default */.Z)(classes.container),
        onMouseDown: handleMouseDown,
        ownerState: ownerState,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogPaper, (0,esm_extends/* default */.Z)({
          as: PaperComponent,
          elevation: 24,
          role: "dialog",
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledby
        }, PaperProps, {
          className: (0,clsx_m/* default */.Z)(classes.paper, PaperProps.className),
          ownerState: ownerState,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dialog_DialogContext.Provider, {
            value: dialogContextValue,
            children: children
          })
        }))
      })
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Dialog_Dialog = (Dialog);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./types/misc.ts
var misc = __webpack_require__(19494);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./services/mixpanel/index.ts
var mixpanel = __webpack_require__(81479);
// EXTERNAL MODULE: ./utils/redis/analytics/AnalyticsEvent.ts
var AnalyticsEvent = __webpack_require__(35571);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 36 modules
var TextField = __webpack_require__(21658);
// EXTERNAL MODULE: ./node_modules/@mui/material/Autocomplete/Autocomplete.js + 20 modules
var Autocomplete = __webpack_require__(50438);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js
var debounce = __webpack_require__(57144);
;// CONCATENATED MODULE: ./components/AsyncAutocomplete/AsyncAutocompleteLocation.tsx





function loadScript(src, position, id) {
    if (!position) {
        return;
    }
    const script = document.createElement("script");
    script.setAttribute("async", "");
    script.setAttribute("id", id);
    script.src = src;
    position.appendChild(script);
}
const autocompleteService = {
    current: null
};
const AsyncAutocompleteLocation = (param)=>{
    let { id , cN , value , setValue  } = param;
    const [inputValue, setInputValue] = react.useState("");
    const [options, setOptions] = react.useState([]);
    const loaded = react.useRef(false);
    if ( true && !loaded.current) {
        // Set callback for Google Maps API.
        // @ts-ignore
        window.googlePlacesApiLoaded = ()=>{};
        if (!document.querySelector("#google-maps")) {
            loadScript("https://maps.googleapis.com/maps/api/js?key=".concat("AIzaSyC66KvqtVD4W13b3ZQ4YEAnM1rtgrBodTg", "&libraries=places&callback=googlePlacesApiLoaded"), document.querySelector("head"), "google-maps");
        }
        loaded.current = true;
    }
    const fetch = react.useMemo(()=>(0,debounce/* default */.Z)((request, callback)=>{
            autocompleteService.current.getPlacePredictions(request, callback);
        }, 400), []);
    react.useEffect(()=>{
        let active = true;
        if (!autocompleteService.current && window.google) {
            autocompleteService.current = new window.google.maps.places.AutocompleteService();
        }
        if (!autocompleteService.current) {
            return undefined;
        }
        if (inputValue === "") {
            setOptions(value ? [
                value
            ] : []);
            return undefined;
        }
        fetch({
            input: inputValue
        }, (results)=>{
            if (active) {
                let newOptions = [];
                if (value) {
                    newOptions = [
                        value
                    ];
                }
                if (results) {
                    newOptions = [
                        ...newOptions,
                        ...results
                    ];
                }
                setOptions(newOptions);
            }
        });
        return ()=>{
            active = false;
        };
    }, [
        value,
        inputValue,
        fetch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
        id: id,
        className: cN,
        classes: {
            root: "bg-white rounded-md",
            inputRoot: "bg-transparent rounded-md",
            // focused: "bg-white",
            input: "text-base bg-transparent bg-white sm:text-sm",
            inputFocused: "focus:ring-0",
            noOptions: "hidden",
            paper: "rounded-none rounded-b-md shadow-sm shadow-black/40",
            listbox: "rounded-none"
        },
        sx: {
            "& .MuiAutocomplete-inputRoot": {
            }
        },
        getOptionLabel: (option)=>typeof option === "string" ? option : option.description,
        filterOptions: (x)=>x,
        options: options,
        autoComplete: true,
        includeInputInList: true,
        filterSelectedOptions: true,
        value: value,
        forcePopupIcon: false,
        noOptionsText: "No locations",
        onChange: (event, newValue)=>{
            setOptions(newValue ? [
                newValue,
                ...options
            ] : options);
            setValue((newValue === null || newValue === void 0 ? void 0 : newValue.description) || "");
        },
        onInputChange: (event, newInputValue)=>{
            setInputValue(newInputValue);
        },
        renderInput: (params)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                ...params,
                fullWidth: true,
                // variant="filled"
                // label="location"
                placeholder: "Filter by Country or City...",
                InputProps: {
                    ...params.InputProps
                }
            }),
        renderOption: (props, option)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                ...props,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "p-0.5 text-sm",
                    children: option.description
                })
            });
        }
    });
};

// EXTERNAL MODULE: ./utils/classNames.ts
var classNames = __webpack_require__(43153);
;// CONCATENATED MODULE: ./components/AsyncAutocomplete/LocationTypeMenu.tsx




const options = [
    {
        value: misc/* LocationType.ONSITE */._i.ONSITE,
        label: "Onsite only"
    },
    // { value: LocationType.ONSITE_AND_REMOTE, label: "Onsite + Remote" },
    {
        value: misc/* LocationType.REMOTE */._i.REMOTE,
        label: "Remote only"
    }
];
const LocationTypeMenu = (param)=>{
    let {} = param;
    // Form state.
    const { register , control , getValues , watch , setValue  } = (0,index_esm/* useFormContext */.Gc)();
    const locationType = watch("locationType");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-1 text-sm font-medium",
        children: options.map((option, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (0,classNames/* classNames */.A)("relative -mr-px mb-1 px-2 py-1 text-xs font-medium hover:z-10", locationType === option.value ? "text-white bg-black hover:text-white" : "text-gray-500 bg-black/5 hover:text-black hover:bg-black/10", i === 0 ? "rounded-l" : "", i === options.length - 1 ? "rounded-r" : ""),
                onClick: ()=>{
                    const v = locationType === option.value ? null : option.value;
                    setValue("locationType", v);
                },
                children: option.label
            }, option.value))
    });
};

;// CONCATENATED MODULE: ./components/AsyncAutocomplete/TagsMenu.tsx



const TagsMenu = (param)=>{
    let { heading , availableTags , name , type ="checkbox"  } = param;
    // Get form context.
    const { watch , setValue  } = (0,index_esm/* useFormContext */.Gc)();
    // Get currently assigned tags.
    const assignedTags = watch(name);
    // Method: toggleAssignedTag.
    const toggleAssignedTag = (tag)=>{
        const isTagIncludedInAssignedTags = assignedTags === null || assignedTags === void 0 ? void 0 : assignedTags.includes(tag);
        const newAssignedTags = type === "radio" ? assignedTags === null || assignedTags === void 0 ? void 0 : assignedTags.filter((assignedTag)=>availableTags.findIndex((param)=>{
                let { id  } = param;
                return id === assignedTag;
            }) === -1) : assignedTags;
        if (isTagIncludedInAssignedTags) {
            setValue(name, newAssignedTags.filter((assignedTag)=>assignedTag !== tag), {
                shouldValidate: false
            });
        } else {
            setValue(name, [
                ...newAssignedTags,
                tag
            ], {
                shouldValidate: false
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        className: "",
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-1 text-sm font-medium",
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: availableTags.map((tag, i)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (0,classNames/* classNames */.A)("relative mb-1 px-2 py-1 text-xs font-medium hover:z-10", (assignedTags === null || assignedTags === void 0 ? void 0 : assignedTags.includes(tag.id)) ? "text-white bg-black/100 hover:text-white" : "text-gray-500 bg-black/5 hover:text-black hover:bg-black/10 ", type === "checkbox" && "mr-1 rounded", type === "radio" && "-mr-px", type === "radio" && i === 0 ? "rounded-l" : "", type === "radio" && i === availableTags.length - 1 ? "rounded-r" : ""),
                        onClick: ()=>{
                            toggleAssignedTag(tag.id);
                        },
                        children: tag.label || tag.id
                    }, tag.id);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./config/config.client.ts
var config_client = __webpack_require__(39223);
;// CONCATENATED MODULE: ./components/AsyncAutocomplete/AsyncAutocompleteSearch.tsx







const AsyncAutocompleteSearch = (param)=>{
    let {} = param;
    const [open, setOpen] = react.useState(false);
    const [options, setOptions] = react.useState([]);
    // Form state.
    const { register , control , getValues , watch , setValue  } = (0,index_esm/* useFormContext */.Gc)();
    const value = getValues("search");
    // Fetch search. (based on search params)
    const fetchSearches = async ()=>{
        const url = "/api/search/search?name=".concat(value);
        return fetch(url).then((res)=>res.json());
    };
    const { isLoading  } = (0,es.useQuery)([
        "search",
        value
    ], fetchSearches, {
        onSuccess: (data)=>{
            const sortedOptions = data.search.sort((a, b)=>a < b ? -1 : a > b ? 1 : 0);
            const sortedOptionsWithAddNewOrganisation = [
                ...sortedOptions,
                value
            ];
            const newOptions = data.length === config_client/* ORGANISATIONS_AUTOCOMPLETE_LIMIT */.DQ ? sortedOptions : sortedOptionsWithAddNewOrganisation;
            setOptions(newOptions);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
        multiple: false,
        classes: {
            root: "",
            inputRoot: "bg-transparent rounded-l-md rounded-r-none hover:bg-white",
            focused: "bg-white rounded-l-md",
            input: "text-base font-medium bg-transparent",
            inputFocused: "focus:ring-0",
            clearIndicator: "mr-2",
            popper: "relative w-full m-0 p-0 shadow border-t",
            paper: "rounded-none shadow-none m-0 p-0",
            listbox: "rounded-none m-0 p-0",
            option: "text-sm m-0 p-0"
        },
        sx: {
            "& .MuiFilledInput-root": {
                backgroundColor: "white",
                paddingLeft: "12px",
                // paddingTop: "22px",
                paddingBottom: "4px"
            },
            "& .MuiFilledInput-root:hover": {
                backgroundColor: "white"
            },
            "& .MuiFilledInput-root.Mui-focused": {
                backgroundColor: "white"
            },
            // labels
            // - default state
            "& .MuiFormLabel-root": {
                paddingLeft: "5px",
                color: "#aaa"
            },
            // - filled state
            "& .MuiInputLabel-filled.Mui-focused": {
                color: "#aaa"
            }
        },
        open: open,
        onOpen: ()=>{
            setOpen(true);
        },
        onClose: ()=>{
            setOpen(false);
        },
        inputValue: value || "",
        onChange: (_, value)=>{
            // triggered by selection
            setValue("search", value);
        },
        onInputChange: (_, value)=>{
            // triggered by clear button
            setValue("search", value);
        },
        options: options,
        freeSolo: true,
        getOptionLabel: (option)=>option || "",
        isOptionEqualToValue: (option, value)=>{
            return option === value;
        },
        loading: isLoading,
        filterSelectedOptions: true,
        renderInput: (params)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                ...params,
                variant: "filled",
                label: "Search by title, skill, or company...",
                onChange: (e)=>{
                    // triggered by typing
                    setValue("search", e.target.value);
                },
                InputProps: {
                    ...params.InputProps,
                    disableUnderline: true
                },
                autoFocus: true
            });
        }
    });
};

;// CONCATENATED MODULE: ./components/JobPostSearchModal/HeaderSearchModal.tsx














const HeaderSearchModal = (param)=>{
    let { formValues , emptyFormValues , open , setOpen  } = param;
    const router = (0,next_router.useRouter)();
    // Modal.
    const [tempFormValues, setTempFormValues] = (0,react.useState)(null); // Used to restore form values when modal is cancelled.
    const theme = (0,useTheme/* default */.Z)();
    const isSmallScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    // Keyboard shortcuts - listen for keys down cmd+k.
    const onKeyDown = (e)=>{
        if (e.metaKey && e.which === 75) {
            setOpen(!open);
        }
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("keydown", onKeyDown);
        return ()=>{
            window.removeEventListener("keydown", onKeyDown);
        };
    });
    const formMethods = (0,index_esm/* useForm */.cI)({
        defaultValues: formValues
    });
    const { register , setValue , watch , handleSubmit , formState: { errors , isDirty  } , control , reset  } = formMethods;
    const search = watch("search");
    const location = watch("location");
    const locationType = watch("locationType");
    const tags = watch("tags");
    // Update url search params.
    const updateCurrentUrlParams = async (searchParams)=>{
        // Tidy up params before pushing to url.
        // - Remove empty / undefined params.
        Object.keys(searchParams).forEach((key)=>(searchParams[key] === undefined || searchParams[key] === null || searchParams[key] === "") && delete searchParams[key]);
        // - Remove page param. (so we display results from page 1)
        delete searchParams["page"];
        // - Remove slug param. (not sure why this is here)
        delete searchParams["slug"];
        // Mixpanel: Record search.
        (0,mixpanel/* mixpanelEvent */.f)({
            name: AnalyticsEvent/* AnalyticsEvent.SEARCH_JOB_POSTS */.s.SEARCH_JOB_POSTS,
            payload: {
                searchParams: searchParams
            }
        });
        // Push new url to router.
        await router.push({
            pathname: "/search",
            query: searchParams
        });
    };
    const numberOfActiveFilters = ()=>{
        let count = 0;
        if (locationType === misc/* LocationType.ONSITE */._i.ONSITE || locationType === misc/* LocationType.REMOTE */._i.REMOTE) {
            count++;
        }
        count += tags.length;
        return count;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog_Dialog, {
            classes: {
                root: "",
                paper: "rounded-md border border-gray-300 shadow-md",
                scrollPaper: "items-start"
            },
            // fullScreen={smallScreen}
            open: open,
            onClose: ()=>{
                reset(tempFormValues);
                setOpen(false);
            },
            BackdropProps: {
                classes: {
                    root: "backdrop-blur-sm bg-gray-400/50"
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, {
                ...formMethods,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit(updateCurrentUrlParams),
                    style: {
                        width: isSmallScreen ? "100%" : 400
                    },
                    className: "flex flex-col overflow-y-auto bg-gray-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-white border-b border-gray-300",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncAutocompleteSearch, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-4 mt-4 mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "my-2 text-xs font-bold uppercase",
                                                children: "Location"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncAutocompleteLocation, {
                                                id: "location",
                                                value: location || null,
                                                setValue: (location)=>{
                                                    setValue("location", location);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationTypeMenu, {})
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-4 mt-2 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "my-2 text-xs font-bold uppercase",
                                            children: "Experience level"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsMenu, {
                                            availableTags: [
                                                {
                                                    id: "junior-level",
                                                    label: "Junior"
                                                },
                                                {
                                                    id: "mid-level",
                                                    label: "Mid-weight"
                                                },
                                                {
                                                    id: "senior-level",
                                                    label: "Senior"
                                                }
                                            ],
                                            name: "tags",
                                            type: "checkbox"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-4 mt-2 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "my-2 text-xs font-bold uppercase",
                                            children: "Job type"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsMenu, {
                                            availableTags: [
                                                {
                                                    id: "full-time",
                                                    label: "Full time"
                                                },
                                                {
                                                    id: "part-time",
                                                    label: "Part time"
                                                },
                                                {
                                                    id: "contract",
                                                    label: "Contract"
                                                },
                                                {
                                                    id: "internship",
                                                    label: "Internship"
                                                }
                                            ],
                                            name: "tags",
                                            type: "checkbox"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-4 mt-2 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "my-2 text-xs font-bold uppercase",
                                            children: "Company size"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsMenu, {
                                            availableTags: [
                                                {
                                                    id: "org-size-b",
                                                    label: "1-10"
                                                },
                                                {
                                                    id: "org-size-c",
                                                    label: "11-50"
                                                },
                                                {
                                                    id: "org-size-d",
                                                    label: "51-200"
                                                },
                                                {
                                                    id: "org-size-e",
                                                    label: "201-500"
                                                },
                                                {
                                                    id: "org-size-f",
                                                    label: "501-1000"
                                                },
                                                {
                                                    id: "org-size-g",
                                                    label: "1001-5000"
                                                },
                                                {
                                                    id: "org-size-h",
                                                    label: "5001-10,000"
                                                },
                                                {
                                                    id: "org-size-i",
                                                    label: "10,001+"
                                                }
                                            ],
                                            name: "tags"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-4 mt-2 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "my-2 text-xs font-bold uppercase",
                                            children: "Benefits"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsMenu, {
                                            availableTags: [
                                                {
                                                    id: "visa-sponsorship",
                                                    label: "Visa sponsorship"
                                                },
                                                {
                                                    id: "paid-relocation",
                                                    label: "Paid relocation"
                                                },
                                                {
                                                    id: "4-day-week",
                                                    label: "4 day week"
                                                }
                                            ],
                                            name: "tags"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "overflow-y-auto"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row justify-between p-4 text-base border-t border-gray-300 sm:text-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "underline",
                                    onClick: ()=>{
                                        reset(emptyFormValues);
                                    },
                                    children: "Clear all"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "submit",
                                        className: "px-8 py-4 text-white bg-black rounded-md hover:text-white/90 sm:px-6 sm:py-2",
                                        onClick: ()=>{
                                            setOpen(false);
                                        },
                                        children: "Search"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 39223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DQ": function() { return /* binding */ ORGANISATIONS_AUTOCOMPLETE_LIMIT; },
/* harmony export */   "Rr": function() { return /* binding */ JOB_POST_PUBLISH_DURATION_IN_DAYS; },
/* harmony export */   "Wt": function() { return /* binding */ QUALITY_SCORE_THRESHOLD; }
/* harmony export */ });
/* unused harmony exports ES_DEFAULT_DISTANCE_IN_KM, TAG_SCORE_THRESHOLD */
// CLIENT CONFIG (public)
const JOB_POST_PUBLISH_DURATION_IN_DAYS = 28;
const ES_DEFAULT_DISTANCE_IN_KM = 100;
const TAG_SCORE_THRESHOLD = 30;
const QUALITY_SCORE_THRESHOLD = 30;
const ORGANISATIONS_AUTOCOMPLETE_LIMIT = 10;


/***/ })

}]);